import Vue from "vue";

export default {
  getVacaciones(parametros) {
    return Vue.axios
      .get("prestaciones/find", { params: parametros })
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },
  getVacacion(id) {
    return Vue.axios
      .get("prestaciones/" + id)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },
  updateVacaciones(parametros) {
    return Vue.axios
      .put("prestaciones", parametros)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },
  deleteVacaciones(id) {
    return Vue.axios
      .delete("prestaciones/" + id)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },
  addVacaciones(parametros) {
    return Vue.axios
      .post("prestaciones", parametros)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },
  getHistoricoVacaciones(parametros){
    return Vue.axios.post("reportes/historico-vacaciones",parametros)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  }
};
